/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_bio = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je suis un développeur full-stack d'Abidjan, Côte d'Ivoire, spécialisé dans la création d'applications web dynamiques et réactives. Avec de l'expérience dans diverses technologies et une passion pour le codage, je m'efforce de créer des expériences numériques impactantes qui résonnent avec les utilisateurs du monde entier.`)
};

const en_bio = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'm a full-stack developer from Abidjan, Côte d'Ivoire, specializing in building dynamic and responsive web applications. With experience in various technologies and a passion for coding, I strive to create impactful digital experiences that resonate with users worldwide.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bio = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bio(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bio", locale)
	if (locale === "fr") return fr_bio(inputs)
	return en_bio(inputs)
};